// Template247: Bélgica - Día 1 Bruselas continuación (Page4.jsx)
// Catedral, Barrio Sablon, tip "Todo este día a pie", Palacio Real + SabiasQue, tip UE, Ruta de los Cómics.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template247 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const catedralTitle = page?.texts?.[1]?.content;
	const catedralBody = page?.texts?.[2]?.content;
	const sablonTitle = page?.texts?.[3]?.content;
	const sablonBody = page?.texts?.[4]?.content;
	const tipPie = page?.texts?.[5]?.content;
	const palacioTitle = page?.texts?.[6]?.content;
	const palacioBody = page?.texts?.[7]?.content;
	const tipUE = page?.texts?.[8]?.content;
	const comicsTitle = page?.texts?.[9]?.content;
	const comicsBody = page?.texts?.[10]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const img1 = getImageSrc("img1");
	const img2 = getImageSrc("img2");
	const stickerImage = getImageSrc("sticker");
	const comicSticker = getImageSrc("comic-sticker");
	const img3 = getImageSrc("img3");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#D4A017";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "4px",
		marginTop: "8px",
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 9999,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					flex: 1,
					display: "flex",
					flexDirection: "column",
					gap: 2,
				}}
			>
				{/* Catedral */}
				<Box data-block-id="text-2" sx={{ display: "flex", gap: 2.5, alignItems: "flex-start" }}>
					{img1 && (
						<Box
							component="img"
							src={img1}
							alt=""
							sx={{
								width: "40%",
								height: 110,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					<Box sx={{ width: "60%" }}>
						{catedralTitle && (
							<Box component="h3" sx={estiloH3}>
								{catedralTitle}
							</Box>
						)}
						{catedralBody && (
							<Box component="p" sx={estiloP}>
								{catedralBody}
							</Box>
						)}
					</Box>
				</Box>

				{/* Barrio Sablon */}
				{(sablonTitle || sablonBody) && (
					<Box data-block-id="text-3" style={{ position: "relative" }}>
						{stickerImage && (
							<Box
								component="img"
								src={stickerImage}
								alt=""
								sx={{
									width: 95,
									position: "absolute",
									...(isSmallScreen
										? { bottom: -200, right: -20 }
										: { bottom: -180, right: 0 }),
								}}
							/>
						)}
						{tipPie && (
							<Box
								sx={{
									position: "absolute",
									...(isSmallScreen
										? { bottom: -180, right: 60 }
										: { bottom: -155, right: 75 }),
									backgroundColor: "#fff8db",
									border: "2px solid #D4A017",
									borderRadius: isSmallScreen
										? "16px 16px 0px 16px"
										: "16px 16px 0px 16px",
									padding: "10px 12px",
									fontSize: "11px",
									color: "#444",
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: isSmallScreen ? 160 : 160,
									zIndex: 9999,
								}}
							>
								{tipPie}
							</Box>
						)}
						<Box
							sx={{
								backgroundColor: "#f9ebc8",
								border: "3px solid #D4A017",
								borderRadius: "12px",
								padding: "8px 12px",
								fontSize: "12px",
								color: "#333",
								marginTop: "8px",
							}}
						>
							{sablonTitle && (
								<Box
									component="h4"
									sx={{
										margin: 0,
										marginBottom: "8px",
										fontSize: "13px",
										fontWeight: 700,
										color: "#8b6914",
										textTransform: "uppercase",
									}}
								>
									{sablonTitle}
								</Box>
							)}
							{sablonBody && (
								<Box component="p" sx={{ ...estiloP, fontSize: "13px" }}>
									{sablonBody}
								</Box>
							)}
						</Box>
					</Box>
				)}

				{/* Palacio Real */}
				<Box
					data-block-id="text-4"
					sx={{
						display: "flex",
						gap: 2.5,
						alignItems: "flex-start",
						position: "relative",
					}}
				>
					{sabiasQue[0] && (
						<Box sx={{ position: "absolute", top: 0, left: "33%" }}>
							<SabiasQue
								icono={sabiasQue[0].icono}
								texto={sabiasQue[0].texto}
							/>
						</Box>
					)}
					{sabiasQue[1] && (
						<Box sx={{ position: "absolute", top: 50, left: "33%" }}>
							<SabiasQue
								icono={sabiasQue[1].icono}
								texto={sabiasQue[1].texto}
							/>
						</Box>
					)}
					{img2 && (
						<Box
							component="img"
							src={img2}
							alt=""
							sx={{
								width: "40%",
								height: 110,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					<Box sx={{ width: "60%", position: "relative" }}>
						{palacioTitle && (
							<Box component="h3" sx={estiloH3}>
								{palacioTitle}
							</Box>
						)}
						{palacioBody && (
							<Box component="p" sx={estiloP}>
								{palacioBody}
							</Box>
						)}
					</Box>
				</Box>
			</Box>

			{/* Tip UE */}
			{tipUE && (
				<Box
					data-block-id="text-5"
					sx={{
						padding: "10px 12px",
						marginTop: isSmallScreen ? "50px" : "20px",
					}}
				>
					<Box
						sx={{
							backgroundColor: "#f9ebc8",
							border: "2px solid #D4A017",
							borderRadius: "12px",
							padding: "8px 14px",
							fontSize: "12px",
							color: "#444",
							textAlign: "center",
						}}
					>
						{tipUE}
					</Box>
				</Box>
			)}

			{/* Ruta de los Cómics */}
			<Box data-block-id="text-6" sx={{ position: "relative" }}>
				<Box sx={{ padding: "10px 12px", position: "relative" }}>
					{comicsTitle && (
						<Box
							component="h3"
							sx={{
								fontSize: "14px",
								fontWeight: 700,
								textTransform: "uppercase",
								margin: 0,
							}}
						>
							{comicsTitle}
						</Box>
					)}
					{comicsBody && (
						<Box component="p" sx={{ ...estiloP, margin: 0 }}>
							{comicsBody}
						</Box>
					)}
					{sabiasQue[2] && (
						<Box sx={{ position: "absolute", top: 0, left: "50%" }}>
							<SabiasQue
								icono={sabiasQue[2].icono}
								texto={sabiasQue[2].texto}
							/>
						</Box>
					)}
				</Box>
				{comicSticker && (
					<Box
						component="img"
						src={comicSticker}
						alt=""
						sx={{ width: 100, position: "absolute", bottom: 20, right: 0 }}
					/>
				)}
				{img3 && (
					<Box
						component="img"
						src={img3}
						alt=""
						sx={{ width: "100%", height: 160, objectFit: "cover" }}
					/>
				)}
			</Box>
		</Box>
	);
};

Template247.thumbnail = "/images/template-1.png";
export default Template247;
